import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstance29ub64y89bvyi as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      static c44(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.u43_1 = operation;
        $this.v43_1 = requestUuid;
        $this.w43_1 = data;
        $this.x43_1 = errors;
        $this.y43_1 = extensions;
        $this.z43_1 = exception;
        $this.a44_1 = Companion_getInstance().r42_1;
        $this.b44_1 = false;
        return $this;
      }
      static d44(operation, requestUuid) {
        return this.c44(operation, requestUuid, null, null, null, null);
      }
      e44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.a44_1 = this.a44_1.f44(executionContext);
        return this;
      }
      g44(data) {
        // Inline function 'kotlin.apply' call
        this.w43_1 = data;
        return this;
      }
      h44(errors) {
        // Inline function 'kotlin.apply' call
        this.x43_1 = errors;
        return this;
      }
      i44(exception) {
        // Inline function 'kotlin.apply' call
        this.z43_1 = exception;
        return this;
      }
      j44(extensions) {
        // Inline function 'kotlin.apply' call
        this.y43_1 = extensions;
        return this;
      }
      s42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.v43_1 = requestUuid;
        return this;
      }
      k44(isLast) {
        // Inline function 'kotlin.apply' call
        this.b44_1 = isLast;
        return this;
      }
      n37() {
        var tmp1_operation = this.u43_1;
        var tmp2_requestUuid = this.v43_1;
        var tmp3_data = this.w43_1;
        var tmp4_executionContext = this.a44_1;
        var tmp0_elvis_lhs = this.y43_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.x43_1;
        var tmp7_exception = this.z43_1;
        var tmp8_isLast = this.b44_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.l44_1 = requestUuid;
        this.m44_1 = operation;
        this.n44_1 = data;
        this.o44_1 = errors;
        this.p44_1 = exception;
        this.q44_1 = extensions;
        this.r44_1 = executionContext;
        this.s44_1 = isLast;
      }
      t44() {
        var tmp;
        if (this.h45()) {
          throw ApolloGraphQLException().g45(first(ensureNotNull(this.o44_1)));
        } else if (!(this.p44_1 == null)) {
          throw DefaultApolloException().z44('An exception happened', this.p44_1);
        } else {
          tmp = this.u44();
        }
        return tmp;
      }
      u44() {
        var tmp0_elvis_lhs = this.n44_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().m45(this.p44_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      h45() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.o44_1;
        return !(this_0 == null || this_0.s1());
      }
      s43() {
        return Builder().c44(this.m44_1, this.l44_1, this.n44_1, this.o44_1, this.q44_1, this.p44_1).e44(this.r44_1).k44(this.s44_1);
      }
      toString() {
        var tmp = 'operationName=' + this.m44_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.n44_1 == null ? 'null' : this.m44_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.o44_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.p44_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.p44_1).o1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
  ApolloResponse as ApolloResponse1aeginapbuksm,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
